import { createReducer } from 'typesafe-actions';
import { asyncState, createAsyncReducer, transformToArray } from '../lib/reducerUtils';
import { MyPageState } from './types';
import { getMyPageUserListAsync , getMyPageUserInviteAsync , postMyPageUserInviteAsync , deleteMyPageUserAsync , getUserInfoAsync , putUserInfoAsync 
       , postUserPwdCheckAsync , getMyPageContactUsListAsync
       , getNeospectraProjectCntAsync
       , getNeospectraProjectStatsAsync
       , getNeospectraJobsStatsAsync
       , getNeospectraUsagesCurrentAsync
       , getNeospectraUsagesServiesLeftAsync
       , putUserRoleAsync
       , putUserGroupRoleAsync
       , getInfoseedMypageAsync
       , resetMyPageDataAsync
       , findCntnListAsync
} from './actions';

import { AnyAction } from 'redux';

const initialState: MyPageState = {
  data: asyncState.initial(),
  cntn : asyncState.initial(),
  inviteList: asyncState.initial(),
  result: asyncState.initial(),
  delResult: asyncState.initial(),
  chkResult: asyncState.initial(),

  neoProjCnt: asyncState.initial(),
  neoProjStat: asyncState.initial(),
  neoJobsStat: asyncState.initial(),
  neoUsagesCurrent: asyncState.initial(),
  neoUsagesServies: asyncState.initial(),

  updateUserRole : asyncState.initial(),
  updateUserGroupRole : asyncState.initial(),

  infoseedMypage : asyncState.initial(),
};

const myPageReducer = createReducer<MyPageState, AnyAction>(initialState)
.handleAction(resetMyPageDataAsync.request, () => initialState)
.handleAction(resetMyPageDataAsync.success, () => initialState)

.handleAction(
  transformToArray(getMyPageUserListAsync),
  createAsyncReducer(getMyPageUserListAsync, 'data')
)
.handleAction(
  transformToArray(getMyPageUserInviteAsync),
  createAsyncReducer(getMyPageUserInviteAsync, 'inviteList')
)
.handleAction(
  transformToArray(postMyPageUserInviteAsync),
  createAsyncReducer(postMyPageUserInviteAsync, 'result')
)
.handleAction(
  transformToArray(deleteMyPageUserAsync),
  createAsyncReducer(deleteMyPageUserAsync, 'delResult')
)
.handleAction(
  transformToArray(getUserInfoAsync),
  createAsyncReducer(getUserInfoAsync, 'data')
)
.handleAction(
  transformToArray(putUserInfoAsync),
  createAsyncReducer(putUserInfoAsync, 'result')
)
.handleAction(
  transformToArray(postUserPwdCheckAsync),
  createAsyncReducer(postUserPwdCheckAsync, 'chkResult')
)
.handleAction(
  transformToArray(getMyPageContactUsListAsync),
  createAsyncReducer(getMyPageContactUsListAsync, 'data')
)
.handleAction(
  transformToArray(getNeospectraProjectCntAsync),
  createAsyncReducer(getNeospectraProjectCntAsync, 'neoProjCnt')
)
.handleAction(
  transformToArray(getNeospectraProjectStatsAsync),
  createAsyncReducer(getNeospectraProjectStatsAsync, 'neoProjStat')
)
.handleAction(
  transformToArray(getNeospectraJobsStatsAsync),
  createAsyncReducer(getNeospectraJobsStatsAsync, 'neoJobsStat')
)
.handleAction(
  transformToArray(getNeospectraUsagesCurrentAsync),
  createAsyncReducer(getNeospectraUsagesCurrentAsync, 'neoUsagesCurrent')
)
.handleAction(
  transformToArray(getNeospectraUsagesServiesLeftAsync),
  createAsyncReducer(getNeospectraUsagesServiesLeftAsync, 'neoUsagesServies')
)
.handleAction(
  transformToArray(putUserRoleAsync),
  createAsyncReducer(putUserRoleAsync, 'updateUserRole')
)
.handleAction(
  transformToArray(putUserGroupRoleAsync),
  createAsyncReducer(putUserGroupRoleAsync, 'updateUserGroupRole')
)
.handleAction(
  transformToArray(getInfoseedMypageAsync),
  createAsyncReducer(getInfoseedMypageAsync, 'infoseedMypage')
)



.handleAction(
  findCntnListAsync.request,
  (state) =>({
    ...state,
    loading: true,
    error: null,
    userList: asyncState.load(),
  })
).handleAction(
  findCntnListAsync.success,
  (state, action) => ({
    ...state,
    data: asyncState.success(action.payload),  // 목록 성공
    loading: false,
    error: null,
  })
).handleAction(
  findCntnListAsync.failure,
  (state, action) => ({
    ...state,
    data: asyncState.error(action.payload),  // 목록 실패
    loading: false,
    error: action.payload,
  }))

export default myPageReducer;